import React, { useState, useEffect, useCallback } from "react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import Dropzone from "react-dropzone"
import { URLS } from "../../Url"
import axios from "axios"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Spinner,
  Alert,
  FormGroup,
} from "reactstrap"

const ProductAddForm = () => {
  const history = useHistory()

  const [formData, setFormData] = useState({
    status: "active",
  })
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [thumbnailImages, setThumbnailImages] = useState([])
  const [description, setDescription] = useState("")

  const [highlights, setHighlights] = useState({
    TopProduct: false,
    NewArrival: false,
    BestProduct: false,
    FeaturedProduct: false,
  })

  const [inputList, setInputList] = useState([
    { key: "", SpecificationaName: "" },
  ])
  const [Spec, setSpec] = useState({ isspecification: false })

  const HandleSpecCheck = e => {
    setSpec(prev => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }))
  }

  const [TaxCategory, setTaxCategory] = useState([])
  const [TaxSubCategory, setTaxSubCategory] = useState([])
  const [categories, setCategories] = useState([])
  const [Store, setStore] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [childCategories, setChildCategories] = useState([])
  const [isLoadingCategories, setIsLoadingCategories] = useState(false)

  const token = JSON.parse(localStorage.getItem("authUser"))?.token

  const fetchTaxCategory = useCallback(async () => {
    setIsLoadingCategories(true)
    try {
      const response = await axios.post(
        URLS.GetTaxCategory,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setTaxCategory(response.data.taxcategorys || [])
    } catch (error) {
      toast.error("Failed to load categories")
    }
  }, [token])

  const fetchCategories = useCallback(async () => {
    setIsLoadingCategories(true)
    try {
      const response = await axios.post(
        URLS.GetCategory,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setCategories(response.data.categorys || [])
    } catch (error) {
      toast.error("Failed to load categories")
    } finally {
      setIsLoadingCategories(false)
    }
  }, [token])

  const fetchStores = useCallback(async () => {
    try {
      const response = await axios.post(
        URLS.GetStore,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setStore(response?.data?.data[0]?._id || [])
    } catch (error) {
      toast.error("Failed to load stores")
    }
  }, [token])

  const handlechanges = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    if (name === "categoryId") {
      fetchSubCategories(value)
    }
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }))
    }
    if (name === "taxcategoryId") {
      fetchTaxSubCategories(value)
    }
  }

  const fetchSubCategories = async data => {
    try {
      const response = await axios.post(
        URLS.GetSubCategory,
        { categoryId: data },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setSubCategories(response.data.data || [])
      setFormData(prev => ({
        ...prev,
        subcategoryId: "",
        childcategoryId: "",
      }))
    } catch (error) {
      toast.error("Failed to load subcategories")
    }
  }

  const fetchTaxSubCategories = async data => {
    try {
      const response = await axios.post(
        URLS.GetTaxSubCategory,
        { taxcategoryId: data },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setTaxSubCategory(response.data.taxsubcategorys || [])
      setFormData(prev => ({
        ...prev,
        taxsubcategoryId: "",
      }))
    } catch (error) {
      toast.error("Failed to load subcategories")
    }
  }

  const handlechangess = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    if (name === "subcategoryId") {
      fetchChildCategories(value)
    }
    // Clear error when field is edited
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }))
    }
  }

  const fetchChildCategories = async data => {
    try {
      const response = await axios.post(
        URLS.GetChildCategories,
        { subcategoryId: data },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      setChildCategories(response.data.data || [])
      setFormData(prev => ({ ...prev, childcategoryId: "" }))
    } catch (error) {
      toast.error("Failed to load child categories")
    }
  }

  useEffect(() => {
    fetchCategories()
    fetchStores()
    fetchTaxCategory()
  }, [fetchCategories, fetchStores, fetchTaxCategory])

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))

    // Clear error when field is edited
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }))
    }
  }

  const handleSpecInputChange = (e, index) => {
    const { name, value } = e.target
    const list = [...inputList]
    list[index][name] = value
    setInputList(list)
  }

  const handleImageUpload = acceptedFiles => {
    if (acceptedFiles.length === 0) return

    const newImages = acceptedFiles.map(file => ({
      file,
      preview: URL.createObjectURL(file),
      name: file.name,
      size: file.size,
      formattedSize: formatFileSize(file.size),
    }))

    setThumbnailImages(prev => [...prev, ...newImages].slice(0, 5))
  }

  const removeImage = index => {
    setThumbnailImages(prev => {
      const newImages = [...prev]
      URL.revokeObjectURL(newImages[index]?.preview)
      newImages.splice(index, 1)
      return newImages
    })
  }

  const formatFileSize = bytes => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2) + " " + sizes[i])
  }

  const HandleCheck = e => {
    const { name, checked } = e.target
    setHighlights(prev => ({
      ...prev,
      [name]: checked,
    }))
  }

  const handleRemoveClick = index => {
    const list = [...inputList]
    list.splice(index, 1)
    setInputList(list)
  }

  const handleAddClick = () => {
    setInputList([...inputList, { key: "", SpecificationaName: "" }])
  }

  const validateForm = () => {
    const newErrors = {}

    // Required fields validation
    if (!formData.name?.trim()) newErrors.name = "Product name is required"
    if (!formData.shortName?.trim())
      newErrors.shortName = "Short name is required"
    if (!formData.categoryId) newErrors.categoryId = "Category is required"
    if (!formData.price) newErrors.price = "Price is required"
    if (thumbnailImages.length === 0) {
      newErrors.thumbnailImages = "At least one image is required"
    }
    if (!description?.trim()) newErrors.description = "Description is required"

    // Numeric validation
    if (formData.price && isNaN(formData.price)) {
      newErrors.price = "Price must be a number"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!validateForm()) {
      toast.error("Please fix the errors in the form")
      return
    }

    setIsSubmitting(true)

    try {
      const formDataToSend = new FormData()
      formDataToSend.append("storeId", Store)
      formDataToSend.append("sku", formData.sku)
      formDataToSend.append("name", formData.name)
      formDataToSend.append("price", formData.price)
      formDataToSend.append("status", formData.status)
      formDataToSend.append("stock", formData.stock)
      formDataToSend.append("taxcategoryId", formData.taxcategoryId)
      formDataToSend.append("taxsubcategoryId", formData.taxsubcategoryId)
      formDataToSend.append("weight", formData.weight)
      formDataToSend.append("shortName", formData.shortName)
      formDataToSend.append("offerPrice", formData.offerPrice)
      formDataToSend.append("categoryId", formData.categoryId)
      formDataToSend.append("subcategoryId", formData.subcategoryId)
      formDataToSend.append("childcategoryId", formData.childcategoryId)
      formDataToSend.append("shortDescription", formData.shortDescription)
      formDataToSend.append("largeDescription", description)
      formDataToSend.append("highlight", JSON.stringify(highlights))
      formDataToSend.append("isspecification", Spec.isspecification)
      formDataToSend.append("specifications", JSON.stringify(inputList))

      // Append images
      thumbnailImages.forEach(image => {
        if (image.file) {
          formDataToSend.append("thumnailImage", image.file)
        }
      })

      const response = await axios.post(URLS.AddProduct, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })

      toast.success(response.data.message || "Product added successfully")
      history.push("/products")
    } catch (error) {
      console.error("Error adding product:", error)
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to add product. Please try again."
      toast.error(errorMessage)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Product Management" breadcrumbItem="Add Product" />
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <h5 className="mb-1 text-primary">Basic Information</h5>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label>Product Name *</Label>
                          <Input
                            type="text"
                            name="name"
                            value={formData.name || ""}
                            onChange={handleInputChange}
                            invalid={!!errors.name}
                            placeholder="Enter product name"
                          />
                          <FormFeedback>{errors.name}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Short Name *</Label>
                          <Input
                            type="text"
                            name="shortName"
                            value={formData.shortName || ""}
                            onChange={handleInputChange}
                            invalid={!!errors.shortName}
                            placeholder="Enter short name"
                          />
                          <FormFeedback>{errors.shortName}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>SKU </Label>
                          <Input
                            type="text"
                            name="sku"
                            value={formData.sku || ""}
                            onChange={handleInputChange}
                            placeholder="Enter SKU"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div className="mb-2">
                    <h5 className="mb-1 text-primary">Pricing</h5>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label>Price *</Label>
                          <Input
                            type="number"
                            name="price"
                            value={formData.price || ""}
                            onChange={handleInputChange}
                            invalid={!!errors.price}
                            placeholder="0.00"
                            min="0"
                            step="0.01"
                          />
                          <FormFeedback>{errors.price}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Quantity </Label>
                          <Input
                            type="number"
                            name="stock"
                            value={formData.stock || ""}
                            onChange={handleInputChange}
                            placeholder="Enter Quantity"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Weight </Label>
                          <Input
                            type="number"
                            name="weight"
                            value={formData.weight || ""}
                            onChange={handleInputChange}
                            placeholder="Enter Weight"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <h5 className="mb-1 text-primary">Categories</h5>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label>Category *</Label>
                          <Input
                            type="select"
                            name="categoryId"
                            value={formData.categoryId || ""}
                            onChange={handlechanges}
                            invalid={!!errors.categoryId}
                            disabled={isLoadingCategories}
                          >
                            <option value="">Select Category</option>
                            {categories.map(category => (
                              <option key={category._id} value={category._id}>
                                {category.name}
                              </option>
                            ))}
                          </Input>
                          <FormFeedback>{errors.categoryId}</FormFeedback>
                          {isLoadingCategories && (
                            <small className="text-muted">
                              Loading categories...
                            </small>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Subcategory</Label>
                          <Input
                            type="select"
                            name="subcategoryId"
                            value={formData.subcategoryId || ""}
                            onChange={handlechangess}
                            disabled={!formData.categoryId}
                          >
                            <option value="">Select Subcategory</option>
                            {subCategories.map(subCategory => (
                              <option
                                key={subCategory._id}
                                value={subCategory._id}
                              >
                                {subCategory.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label>Child Category</Label>
                          <Input
                            type="select"
                            name="childcategoryId"
                            value={formData.childcategoryId || ""}
                            onChange={handleInputChange}
                            disabled={!formData.subcategoryId}
                          >
                            <option value="">Select Child Category</option>
                            {childCategories.map(childCategory => (
                              <option
                                key={childCategory._id}
                                value={childCategory._id}
                              >
                                {childCategory.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <h5 className="mb-1 text-primary">Taxation </h5>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label>Tax Category *</Label>
                          <Input
                            type="select"
                            name="taxcategoryId"
                            value={formData.taxcategoryId || ""}
                            onChange={handlechanges}
                          >
                            <option value="">Select Tax Category</option>
                            {TaxCategory.map(taxcategory => (
                              <option
                                key={taxcategory._id}
                                value={taxcategory._id}
                              >
                                {taxcategory.name}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="8">
                        <FormGroup>
                          <Label>Tax Sub Category *</Label>
                          <Input
                            type="select"
                            name="taxsubcategoryId"
                            value={formData.taxsubcategoryId || ""}
                            onChange={handlechanges}
                            disabled={!formData.taxcategoryId}
                          >
                            <option value="">Select Tax Sub Category</option>
                            {TaxSubCategory.map(taxsubcategory => (
                              <option
                                key={taxsubcategory._id}
                                value={taxsubcategory._id}
                              >
                                {taxsubcategory.name} / (
                                {taxsubcategory.tax_rate} %)
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div className="mb-4">
                    <h5 className="mb-1 text-primary">Product Images</h5>
                    {errors.thumbnailImages && (
                      <Alert color="danger">{errors.thumbnailImages}</Alert>
                    )}
                    <Row>
                      <Col md="12">
                        <Dropzone
                          onDrop={handleImageUpload}
                          accept="image/*"
                          maxSize={5242880}
                          multiple
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              {...getRootProps()}
                              className="dropzone border rounded p-4 text-center"
                              style={{
                                borderStyle: "dashed",
                                cursor: "pointer",
                                backgroundColor: "#f8f9fa",
                              }}
                            >
                              <input {...getInputProps()} />
                              <div className="mb-1">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                              </div>
                              <h5>
                                Drag and drop images here, or click to select
                              </h5>
                              <p className="text-muted">
                                Maximum 5 images (Max size: 5MB each)
                              </p>
                            </div>
                          )}
                        </Dropzone>
                      </Col>
                    </Row>
                    {thumbnailImages.length > 0 && (
                      <Row className="mt-3">
                        <Col md="12">
                          <h6 className="mb-2">Selected Images:</h6>
                          <div className="d-flex flex-wrap">
                            {thumbnailImages.map((image, index) => (
                              <div
                                key={index}
                                className="position-relative m-2"
                                style={{ width: "120px" }}
                              >
                                <img
                                  src={
                                    typeof image === "string"
                                      ? image
                                      : image.preview
                                  }
                                  alt={`Preview ${index + 1}`}
                                  className="img-thumbnail"
                                  style={{
                                    height: "120px",
                                    objectFit: "cover",
                                  }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                  style={{ transform: "translate(50%, -50%)" }}
                                  onClick={e => {
                                    e.stopPropagation()
                                    removeImage(index)
                                  }}
                                >
                                  <i className="bx bx-x" />
                                </button>
                                <div className="small text-truncate mt-1">
                                  {typeof image === "string"
                                    ? image.split("/").pop()
                                    : image.name}
                                </div>
                                <div className="small text-muted">
                                  {typeof image === "string"
                                    ? "Unknown size"
                                    : image.formattedSize}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    )}
                  </div>
                  <div className="mb-4">
                    <h5 className="mb-1 text-primary">Descriptions</h5>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label>Short Description</Label>
                          <Input
                            type="textarea"
                            name="shortDescription"
                            value={formData.shortDescription || ""}
                            onChange={handleInputChange}
                            rows="4"
                            placeholder="Enter short description"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label>Detailed Description *</Label>
                          {errors.description && (
                            <Alert color="danger" className="mb-2">
                              {errors.description}
                            </Alert>
                          )}
                          <CKEditor
                            editor={ClassicEditor}
                            data={description}
                            onChange={(event, editor) => {
                              setDescription(editor.getData())
                              if (errors.description) {
                                setErrors(prev => ({
                                  ...prev,
                                  description: "",
                                }))
                              }
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "insertTable",
                                "undo",
                                "redo",
                              ],
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <div className="mb-2">
                    <h5 className="mb-1 text-primary">Product Highlights</h5>
                    <Row className="mt-3">
                      <Col md={2}>
                        <Label>Highlight :</Label>
                      </Col>
                      <Col md={12} className="d-flex pb-4">
                        <div className="form-check me-3 me-lg-5">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            name="TopProduct"
                            value={highlights.TopProduct}
                            onChange={HandleCheck}
                            id="TopProduct"
                            style={{ fontSize: "20px" }}
                          />
                          <Label
                            className="form-check-label pt-1"
                            htmlFor="TopProduct"
                          >
                            Top Product
                          </Label>
                        </div>
                        <div className="form-check me-lg-5">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            name="NewArrival"
                            value={highlights.NewArrival}
                            onChange={HandleCheck}
                            id="NewArrival"
                            style={{ fontSize: "20px" }}
                          />
                          <Label
                            className="form-check-label pt-1"
                            htmlFor="NewArrival"
                          >
                            New Arrival
                          </Label>
                        </div>
                        <div className="form-check me-3 me-lg-5">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            name="BestProduct"
                            onChange={HandleCheck}
                            value={highlights.BestProduct}
                            id="BestProduct"
                            style={{ fontSize: "20px" }}
                          />
                          <Label
                            className="form-check-label pt-1"
                            htmlFor="BestProduct"
                          >
                            Best Product
                          </Label>
                        </div>
                        <div className="form-check me-3 me-lg-5">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            name="FeaturedProduct"
                            value={highlights.FeaturedProduct}
                            onChange={HandleCheck}
                            id="FeaturedProduct"
                            style={{ fontSize: "20px" }}
                          />
                          <Label
                            className="form-check-label pt-1"
                            htmlFor="FeaturedProduct"
                          >
                            Featured Product
                          </Label>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="mb-4">
                    <h5 className="mb-1 text-primary">Specifications</h5>
                    <Row>
                      <Col md="12">
                        <div className="d-flex align-items-center mb-1">
                          <div className="form-check form-switch me-3">
                            <Input
                              type="switch"
                              id="isspecification"
                              name="isspecification"
                              value={Spec.isspecification}
                              onChange={HandleSpecCheck}
                              className="form-check-input"
                            />
                            <Label
                              htmlFor="isspecification"
                              className="form-check-label"
                            >
                              Enable Specifications
                            </Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {Spec.isspecification && (
                      <Col md={12}>
                        <div>
                          <Row>
                            {inputList.map((x, i) => (
                              <Row key={i}>
                                <div className="box row">
                                  <Col md="5" sm="12" className="mb-1">
                                    <Label>Key</Label>
                                    <Input
                                      type="text"
                                      required
                                      name="key"
                                      placeholder="Enter Key"
                                      value={x.key}
                                      onChange={e =>
                                        handleSpecInputChange(e, i)
                                      }
                                    />
                                  </Col>
                                  <Col md="5" sm="12" className="mb-1">
                                    <Label>Specification</Label>
                                    <Input
                                      type="text"
                                      required
                                      name="SpecificationaName"
                                      placeholder="Enter Specification"
                                      value={x.SpecificationaName}
                                      onChange={e =>
                                        handleSpecInputChange(e, i)
                                      }
                                    />
                                  </Col>
                                  <Col sm="2">
                                    <Label className="mt-1"></Label>
                                    <div className="btn-box">
                                      {inputList.length !== 1 && (
                                        <button
                                          className="mr10 btn btn-outline-danger btn-sm m-1 mt-3"
                                          type="button"
                                          onClick={() => handleRemoveClick(i)}
                                        >
                                          Remove
                                          <i className="bx bx-x-circle"></i>
                                        </button>
                                      )}
                                      {inputList.length - 1 === i && (
                                        <button
                                          className="btn btn-sm btn-outline-info m-1 mt-3"
                                          type="button"
                                          onClick={handleAddClick}
                                        >
                                          Add
                                          <i className="bx bx-plus-circle"></i>
                                        </button>
                                      )}
                                    </div>
                                  </Col>
                                </div>
                              </Row>
                            ))}
                          </Row>
                        </div>
                      </Col>
                    )}
                  </div>
                  <div className="d-flex justify-content-between mt-4">
                    <Button
                      color="primary"
                      onClick={() => history.goBack()}
                      disabled={isSubmitting}
                      size="sm"
                    >
                      <i className="bx bx-arrow-back me-1" /> Back
                    </Button>
                    <Button
                      color="primary"
                      type="submit"
                      disabled={isSubmitting}
                      size="sm"
                    >
                      {isSubmitting ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Adding Product...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-check-circle me-1" /> Add Product
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ProductAddForm
